import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4"
        >
            <p className="text-8xl font-bold text-slate-200 select-none">404</p>
            <h1 className="mt-4 text-2xl font-semibold text-slate-700">
                Oops, this page does not exist
            </h1>
            <p className="mt-2 text-slate-500">
                The page you're looking for couldn't be found.
            </p>
            <Button
                className="mt-8 gap-2"
                onClick={() => navigate("/portal/home")}
            >
                <Home size={16} />
                Back to Portal
            </Button>
        </motion.div>
    );
}
